// extracted by mini-css-extract-plugin
export var currencyInput = "_og-1";
export var currencySymbol = "_og-0";